import { css } from 'styled-components';

// Get effective font-size
export const getFontSize = () => {
  let fontSize = 20;
  let el = document.getElementById('root');

  if (el) {
    let style = window.getComputedStyle(el, null).getPropertyValue('font-size');

    fontSize = parseFloat(style);
  }

  return fontSize;
};

const rootStyle = css`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  user-select: none;
  font-family: ChallYantramanav, OpenSans;
  cursor: default;
`;

const infusedRootStyle = css`
  html,
  body {
    height: 100vh;
    font-size: ${getFontSize()}px;
    ${rootStyle}
  }
`;

const baseStyle = css`
  ${__BUILD_MODE__ === 'production' ? rootStyle : infusedRootStyle}

  img {
    user-select: none;
    -webkit-user-drag: none;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
`;

export default baseStyle;
